import { DotNetComponent } from "../../typings/global";
import { loadElemIfReady } from "./helpers";
import { MapComponent } from '../map';

let googleMapsLoaded = false;
let mapContentLoaded = false;
let mapDotNetReference: DotNetComponent | null = null;


export function initGoogleAutocomplete(
  elementId: string,
  dotNetHelper: DotNetComponent
): void {
  const input = document.getElementById(elementId) as HTMLInputElement | null;
  if (!input || !google?.maps?.places) return;

  const autocomplete = new google.maps.places.Autocomplete(input, {
    componentRestrictions: { country: 'CH' },
  });

  autocomplete.addListener('place_changed', () => {
    const place = autocomplete.getPlace();
    if (place?.formatted_address) {
      const addressWithoutCountry = place.formatted_address.replace(/,\s*[^,]+$/, '');
      dotNetHelper.invokeMethodAsync('OnAddressSelected', addressWithoutCountry);
      input.value = '';
    }
  });
}

/**
 * Called from Blazor to initiate map loading
 */
export function loadMap(dotNetReference: DotNetComponent): void {
    mapContentLoaded = true;
    mapDotNetReference = dotNetReference;

    if (googleMapsLoaded) {
        loadElemIfReady('.js-map', (elem) => new MapComponent(elem, mapDotNetReference));
    }
}

/**
 * Called when Google Maps API has finished loading
 */
export function googleMapsLoadedCallback(): void {
    googleMapsLoaded = true;

    if (mapContentLoaded) {
        loadElemIfReady('.js-map', (elem) => new MapComponent(elem, mapDotNetReference));
    }
}
